/* eslint-disable */
import React, { useEffect, useState } from "react";
// import { Stack, Form, Col, Row, Button } from "react-bootstrap";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import {
  appUserActivity,
  deleteAppUserEmails,
} from "../../../redux/actions/crmActions";
import "../../crmComponents/Leadtabs.css";
import { useParams } from "react-router";
import SummaryCard from "./SummaryCard";
import moment from "moment";
import * as Icon from "react-bootstrap-icons";
import { useNavigate } from 'react-router-dom';
// import DeleteModal from "../../../../../shared/DeleteModal";

const AccountDetailedHistory = (props) => {
  const { id } = useParams();
  const { authToken } = props;
  const { contactId } = props;
  const navigate = useNavigate();
  const [deleteId, SetDeleteId] = useState(0);
  const [dltDialog, SetDltDialog] = useState(false);
  const [activeCards, setActiveCards] = useState([]);
  const accountDetails = useSelector((state) => state.account.account_details);
  const userDetails = useSelector((state) => state.crmLeads.userActivityDetails);


  const uName = userDetails?.data?.response?.name

  const dispatch = useDispatch();

  // const userDetails = useSelector((state) => state.crmLeads.userActivityDetails);
  const dates = new Date();

  const getDate = (date) => {
    if (date !== "" && date !== null && date !== "0000-00-00 00:00:00") {
      let d = moment(date).format("DD");
      return d;
    }
  };

  const getMonth = (date) => {
    if (date !== "" && date !== null && date !== "0000-00-00 00:00:00") {
      const dates = new Date();
      let m = moment(date).format("MMM");
      return m.toUpperCase();
    }
  };

  const deleteEmail = () => {
    let idd = id !== undefined ? id : contactId.contact_ids[0].contact_id;
    SetDeleteId(0);
    SetDltDialog(false);
    dispatch(deleteAppUserEmails(authToken, [deleteId], idd));
  };

  const hideDialog = () => {
    SetDeleteId(0);
    SetDltDialog(false);
  };

  const openModal = (val) => {
    SetDeleteId(val.id);
    SetDltDialog(true);
  };
  
  useEffect(()=>{
    const uData = JSON.parse(localStorage.getItem("userData"));
    if(uData?.stripeData?.stripe_day_count === 0){
      navigate(`/404`);
    }
  },[])

  return (
    <div className="offcanvas-body-background detailedHistory middlePiece">
      {accountDetails && (
      <div className="h-[82vh] max-sm:h-[48vh] overflow-y-auto w-full listing">
        {accountDetails?.detailed_history?.length > 0 ? (
          accountDetails?.detailed_history.map((item, i) => {
            return (
              <SummaryCard item={item} index={i} />
            );
          })
        ) : (
          <div className="text-[rgba(33,33,33,0.3)] py-[50px] text-[17px] font-[bolder] text-center font-add">
            <span className="flex justify-center text-[40px]">
              <Icon.Inbox />
            </span>
            No Data
          </div>
        )}
      </div>
     )} 
    </div>
  );
};

export default AccountDetailedHistory;
